var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconTogglesBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m7.76,13.54h0c2.63,0,4.91,1.92,5.24,4.52,1.58,12.34,9.49,21.75,18.99,21.75s17.41-9.41,18.99-21.75c.33-2.61,2.62-4.52,5.24-4.52h0c3.22,0,5.7,2.85,5.28,6.04-2.34,17.49-14.69,30.87-29.51,30.87S4.83,37.08,2.49,19.59c-.43-3.19,2.05-6.04,5.28-6.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconTogglesBottom);
export default __webpack_public_path__ + "static/media/SDS_icon_Toggles_Bottom.351ef798a1f3bef32fe75c3e816bc896.svg";
export { ForwardRef as ReactComponent };